import { ChangeEvent, FocusEvent } from 'react'

import { capitalize, FormControl, FormLabel, SxProps } from '@mui/material'
import CheckBox from '@mui/material/Checkbox'
import Grid from '@mui/material/Grid2'
import theme from '@rfh-core/theme'

type LabelCheckboxProps = {
  label: string
  fieldName: string
  onChange?: (event: ChangeEvent<HTMLInputElement>) => void
  onBlur?: (event: FocusEvent<HTMLButtonElement>) => void
  value: boolean
  disabled?: boolean
  flowDirection?: 'row' | 'column' | 'column-reverse' | 'row-reverse'
  sx?: SxProps
}

export default function LabelCheckbox({
  label,
  fieldName,
  flowDirection = 'column',
  onChange,
  onBlur,
  value = false,
  disabled,
  sx,
}: Readonly<LabelCheckboxProps>): JSX.Element {
  return (
    <Grid
      container
      direction={flowDirection}
      justifyContent={'flex-start'}
      alignItems={'center'}
    >
      <Grid>
        <FormControl fullWidth>
          <FormLabel
            htmlFor={`id-${fieldName}`}
            sx={{
              color: theme.rfhColors.black,
              whiteSpace: 'nowrap',
              minWidth: 120,
              textAlign: 'center',
              fontFamily: 'Halyard-display',
              fontSize: '1rem',
              fontWeight: 'bold',
              ...sx,
            }}
          >
            {capitalize(label)}
          </FormLabel>
        </FormControl>
      </Grid>
      <Grid>
        <FormControl fullWidth>
          <CheckBox
            id={`id-${fieldName}`}
            name={fieldName}
            disabled={disabled}
            onChange={onChange}
            onBlur={onBlur}
            checked={value}
          />
        </FormControl>
      </Grid>
    </Grid>
  )
}
